export class XeroProcessAuthorizationCodeRequest{
    public code!:string;
    public scope!:string;
    public state!: string;
    public nonce!: string;
}